import React from "react";
import styled from "styled-components";
import moment from "moment";
// typo
import {Tag} from 'antd'

import typo from "../../../constants/dictionaries";
import helper from '../../../helper/helper'
// Colors
import colors, { getColorFromStatus } from "../../../constants/colors";

const Status = ({ value, trangthai } = {}) => {
  if (trangthai === 0 ||  trangthai === null || trangthai === undefined) {
    return <Tag color="gold">{typo.cscore_chua_danh_gia}</Tag>
  } else if (trangthai === 1) {
    return <Tag color="red">{typo.cscore_vuot_chi_so}</Tag>
  } else if (trangthai === 2) {
    return <Tag color="green">{typo.cscore_trong_nguong}</Tag>
  }
};

export default Status;
